<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Beginner Tutorial')}}</div>
        </div>
        <div>
            <img src="@/assets/images/doc.png" style="width: 100%;height: 210px;">
        </div>
        <div class="wrap custom">
            <div class="docs-title">{{$t('Beginner Tutorial')}}</div>
            <van-grid v-if="docList.length > 0" :column-num="2" :border="false" :gutter="10">
                <van-grid-item
                        v-for="item in docList"
                        :key="item.id"
                        @click="goDetail(item)"
                >
                    <div class="doc-item">
                        <van-image
                                :src="item.img"
                                width="100%"
                                height="120"
                                fit="cover"
                                radius="0"
                        />
                        <div class="doc-title-wrap">
                            <div class="doc-title">{{ item.title }}</div>
                        </div>
                    </div>
                </van-grid-item>
            </van-grid>
            <van-empty  v-else
                        class="custom-image"
                        :image="require('@/assets/images/custom-empty-image.png')"
                        :description="$t('No data')"
            />
        </div>
        <div style="height: 30px;" v-if="docList.length > 0"></div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "docs",
        data() {
            return {
                docList: [],
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.getDocs();
        },
        methods: {
            getDocs() {
                Fetch('/index/docs', { }).then(res => {
                    this.docList = res.data;
                })
            },
            goDetail(item) {
                this.$router.push('/docs/'+item.id)
            },
        },
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }

    .big_tit {
        color: #000000;
    }

    .wrap {
        padding: 10px;
    }
    .docs-title {
        padding: 10px 10px 15px 10px;
        font-size: 16px;
        font-weight: bold;
        color: #000;
    }

    .doc-item {
        display: flex;
        flex-direction: column;
        background: #fff;
        box-shadow: 0 2px 5px rgba(0, 0, 0, .1);
        overflow: hidden;
    }

    .doc-title-wrap {
        padding: 10px;
    }

    .doc-title {
        font-size: 14px;
        color: #333;
        line-height: 1.4;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
</style>